import { render, staticRenderFns } from "./EmailNotificationSettings.vue?vue&type=template&id=46f3fb25&"
import script from "./EmailNotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./EmailNotificationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports